import packageJson from '../../package.json';

const {
  REACT_APP_BASE_BACKEND_URL = 'http://localhost:3000',
  REACT_APP_ENV = 'local',
  REACT_APP_BASE_DOMAIN = 'http://localhost:3001',
  REACT_APP_DOMAIN = 'sub.localhost:3001',
  REACT_APP_MAINTENANCE_MODE = 'false',
  NODE_ENV = 'development',
  REACT_APP_PAYWAY_PUBLIC_KEY = 'tovPBDlVz2MjBBbSOlqD0M2IbgiY8bqx',
  REACT_APP_NAVE_PUBLIC_KEY = 'b06704da-4b9a-4f87-81f1-a8d3a645d673',
} = process.env;

const normalizedEnv = (REACT_APP_ENV || '').toLowerCase();
const isProductionEnv = normalizedEnv === 'prod' || normalizedEnv === 'production';
const isProductionBuild = NODE_ENV === 'production';

const config = {
  baseURL: REACT_APP_BASE_BACKEND_URL,
  version: packageJson.version,
  env: REACT_APP_ENV,
  baseDomain: REACT_APP_BASE_DOMAIN,
  production: isProductionEnv || isProductionBuild,
  domain: REACT_APP_DOMAIN,
  maintenanceMode: REACT_APP_MAINTENANCE_MODE,
  paywayPublicKey: REACT_APP_PAYWAY_PUBLIC_KEY,
  navePublicKey: REACT_APP_NAVE_PUBLIC_KEY,
};

export default config;
